import axios from 'axios'
import {apiToGroup} from './converters'

const API_V1_URL = process.env.API_V1_URL

export default {
  create(name) {
    return axios.post(API_V1_URL + '/cgroups', {name})
      .then(res => res.data)
  },
  update({id, name}) {
    return axios.patch(API_V1_URL + '/cgroup/' + id, {name})
  },
  delete(groupId) {
    return axios.delete(API_V1_URL + '/cgroup/' + groupId)
  },
  getList() {
    return axios.get(API_V1_URL + '/cgroups')
      .then(res => res.data.map(apiToGroup))
  },
  getGroupClients(groupId) {
    return axios.get(API_V1_URL + '/cgroup/' + groupId)
  },
}



// WEBPACK FOOTER //
// ./src/-service-app/services/groupService.js